import React, {forwardRef} from "react";
import css from "./PageContainer.module.scss";
import {usePageContainerContext} from "./PageContainerContext.jsx";

const PageContainer = forwardRef(({
  children,
  className = '',
  wide,
  style,
  ...props
}, ref) => {
  const context = usePageContainerContext();
  const isWide = wide ?? context?.wide ?? false;

  return (
    <div
      ref={ref}
      className={`${css.pageContainer} ${isWide ? css.wide : ''} ${className}`}
      style={{...style}}
      {...props}
    >
      {children}
    </div>
  );
});

PageContainer.displayName = "PageContainer";

export default PageContainer;
